/**
 * Formata número como percentual com 1 casa decimal e vírgula.
 * Ex: 45.678 → "45,7"
 */
export const formatPct = (value) => {
    return Number(value).toFixed(1).replace('.', ',');
};
